import { useState } from "react";
import Page404 from "@pages/NotFoundPage"
import { useTranslation } from "react-i18next";
import PageHeader from "@components/PageHeader";

const NoChildPage = () => {
    const { t } = useTranslation();
    const [isPageNotFound, setIsPageNotFound] = useState(false);
    
    return (
        <div className="mx-3 mb-5 mb-lg-0">
            {isPageNotFound ? (<Page404 />) : (
                <div>
                    <div className="sticky-top sticky-header border-bottom border-light">
                    <PageHeader pageTitle={t("button.back")} flagSearch={false} flag={false}/>
                    </div>
                    <div 
                          className="position-absolute mt-5 text-white text-uppercase"
                          style={{
                            top:"50%",
                            left:"50%",
                            transform: "translatex(-50%)"
                          }} 
                        >
                          {t('text.child_not_found')}😢
                        </div>
                </div>)}
        </div>
    )
}
export default NoChildPage